var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDoppePageDefaultImageCoverPhotoInner = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 360 160",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360 0H0v160h360V0zM148.354 61.987c-8.05 0-14.58-6.495-14.58-14.494S140.304 33 148.354 33c8.045 0 14.569 6.494 14.569 14.493 0 8-6.524 14.494-14.569 14.494zM276.168 126H300l-74.271-79.765c-2.166-1.427-5.676-1.427-7.842 0l-67.51 44.53c-2.159 1.428-5.669 1.428-7.835 0l-15.704-10.36c-2.159-1.427-5.669-1.427-7.835 0L59 126h217.168z"
  })));
});
export default SvgDoppePageDefaultImageCoverPhotoInner;